import { MouseEvent } from 'react';

const handleClickOnActiveElement = (e: MouseEvent<HTMLElement>) => {
  e.stopPropagation();
};

export default handleClickOnActiveElement;
